module.exports = __webpack_public_path__ + "img/logo.d9fc3b43.svg";